/**
 * Override native JavaScript methods
 */

// Override console.log to display nothing in production
if (import.meta.env.MODE === "production") {
  console.log = () => {}
}
